import { messageService } from 'src/app/message.service';
import { Component, HostListener, OnInit, TemplateRef, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MsalService } from '@azure/msal-angular';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { qmsService } from '../qms/qms.service';
import { interval } from 'rxjs';
import moment from 'moment';
import { SessionTimeoutService } from '../session-timeout-dialog/session-timeout.service';
import { GlobalLoaderService } from '../global-loader.service';

@Component({
  selector: 'app-launch-training',
  templateUrl: './launch-training.component.html',
  styleUrls: ['./launch-training.component.scss']
})
export class LaunchTrainingComponent implements OnInit, OnDestroy {

  trainingData: any;
  contentList: any = [];
  content: any = {};
  userprofilename: any;
  dropDownForCategories = [];
  varForTickMark = 1;
  trainingGroupData: any = [];
  isMinimumTimeCompleted = true;
  isTimerActive = false;
  isRetakeActive: boolean = false;

  visibleModalConfirmPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('modalConfirmPopup', { static: true }) modalConfirmPopup: TemplateRef<any>;
  isAdEnabled = false;

  constructor(private appService: AppService, private cdr: ChangeDetectorRef, private router: Router, private snackBar: MatSnackBar, private qmsservice: qmsService, private messageService: messageService,
    public dialog: MatDialog, public sanitizer: DomSanitizer, private authService: MsalService, private readonly sessionTimeoutService: SessionTimeoutService, private globalLoader: GlobalLoaderService) {

    const data: any = router.getCurrentNavigation()?.extras.state;
    this.trainingData = this.appService.getTrainingData();
  }

  modalConfirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  isEsignRequired: boolean = false;
  reasonForSign: any;
  cerFilePath: any;;
  cerFileName: any;;
  userName: any;
  password: any = '';
  userDetails: any = {};
  oneQmsOrgUsersDetails: any;
  reasonForSignatureList: any = [];
  reasonForSignature: any;
  reasonSearchText: string = '';
  displayUserName: any;
  ngOnInit(): void {
    this.isAdEnabled = localStorage.getItem("adEnabled") == 'Y';

    console.log("this.isAdEnabled=", this.isAdEnabled);
    setTimeout(() => {

      let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
      this.displayUserName = userData.userNameAtApplication;
      if (this.x != undefined) {
        clearInterval(this.x);
      }
      this.userName = localStorage.getItem("loggedUserName");
      this.oneQmsOrgUsersDetails = JSON.parse(sessionStorage.getItem('oneQmsOrgUsersDetails') || '{}');

      this.appService.getGroupTrainingDetailsById(this.trainingData['groupId'],
        this.trainingData['trainingId'], this.trainingData['version']).subscribe((data: any) => {
          this.trainingGroupData = data[0];
          this.noOfAttempt = this.trainingGroupData.allowedFailedAttempts;

        })
      this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
        if (response != null) {
          if (response.esignatureAtTrainingCompletion == "Y") {
            this.isEsignRequired = true;
          } else {
            this.isEsignRequired = false;
          }

          let data = {
            stageName: 'Completion',
            status: 'Complete',
            module: "TRN",
          }
          this.appService.getReasonForSigns(data).subscribe((data: any) => {
            this.reasonForSignatureList = data;
            if (data.length == 1) {
              this.reasonForSign = data[0].reasonForSignature;
            }

          })

          this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
            this.userDetails = data[0];
          })
        }
      })

      this.appService.getAllOrgReportImages().subscribe((response1: any) => {
        this.oneQmsOrgImagesDetails = response1;
      })

      this.appService.getOneQmsOrganization().subscribe((data: any) => {
        this.orgData = data;
      })
      this.userprofilename = localStorage.getItem("userprofilename");

      this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
        this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
          this.contentList = data;

          this.getContentListAndCalculateProgress(this.contentList);
          if (this.contentList.length == 1) {
            this.getContentDataForLaunch(this.contentList[0]);
            this.firstdisplay = true;
            this.previousdisplay = true;
            this.copmletedisplay = true;
          } else {
            this.firstdisplay = false;
            this.previousdisplay = false;
            this.copmletedisplay = false;
            for (let i = 0; i < this.contentList.length; i++) {
              if (this.contentList[i].status != "Completed") {
                this.previousContentSeq = i + 1;
                let k = i;
                i = this.contentList.length;
                this.getContentDataForLaunch(this.contentList[k]);
              }
            }
            if (this.previousContentSeq >= 1) {
            } else {
              this.getContentDataForLaunch(this.contentList[this.contentList.length - 1]);
            }
          }

        })
    });
  }

  onReasonSelect(event: any, item: any) {
    if (event.isUserInput) {

    }
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  getOptionsForQuestion(question: any, content: any) {
    this.appService.getQuestionOptionsList(question['trainingId'],
      question['version'], question['contentId'], question['questionId']).subscribe((data: any) => {
        question['optionsList'] = data;
      })
  }

  quizdisplay: boolean = false;
  pdfdisplay: boolean = false;
  videodisplay: boolean = false;
  previousContentSeq: any;
  previoustrainingContentId: any;
  counterVariable = 0;
  assessmentDataForQuestions: any;
  isPreviewPage: boolean = false;
  questionDataOfAssessment: any;
  correctAnse: any = [];
  quizdisplayfpr: any = [];
  noofCorrectAnsw = 0;
  noofWrongAnsw = 0;
  newNum: any;
  scoreperc: any;
  alertMsg: any;
  documentData: any;
  viewerData: any;

  getContentDataForLaunch(clickedData: any) {

    console.log("clickedData=", clickedData);
    this.showRetakeTime = false;
    this.alertShow = false;
    this.isCompletedPage = false;

    this.clickedContent = clickedData;
    this.quizdisplay = false;
    this.pdfdisplay = false;
    this.varForTickMark = clickedData.contentSeq;
    this.videodisplay = false;
    if (clickedData.isQuestionContent == "N" || clickedData.isQuestionContent == null) {
      if (clickedData.documentId != null) {

        clickedData['trainingStatus'] = this.trainingData['status'];
        this.appService.getDocumentByDocumentId(
          clickedData.documentId, clickedData.documentVersion).subscribe((data: any) => {
            if (data.length > 0) {
              this.documentData = data[0];

              clickedData['contentExtn'] = this.documentData['documentExtn'];

              let obj = {
                trainingId: this.trainingData['trainingId'],
                version: this.trainingData['version'],
                contentId: clickedData['contentId'],
                status: this.trainingData['status'],
                contentExtn: clickedData['contentExtn']
              }
              this.appService.getDocumentsToViewForLaunch(obj)
                .subscribe((data: any) => {
                  if (clickedData['contentExtn'] == 'txt' || clickedData['contentExtn'] == 'TXT') {
                    let blob = new Blob([data.body], { type: 'text/plain' });
                    let url = URL.createObjectURL(blob);
                    let iframee: any = document.getElementById("myIframe");
                    iframee.oncontextmenu = function () { return false; };
                    iframee.src = url + "#toolbar=0";
                  } else
                    if (clickedData['contentExtn'] == 'mp4') {
                      console.log("clickedData['contentExtn']", clickedData['contentExtn']);
                      try {
                        let blob = new Blob([data.body], { type: "video/mp4" });
                        console.log("blob")
                        let url = URL.createObjectURL(blob);
                        console.log(url)
                        let video = <HTMLVideoElement>document.getElementById('videoarea');
                        console.log(video)
                        video.src = url;
                        video.style.display = "block";
                        video.load();
                        video.crossOrigin = 'anonymous';
                        video.play();
                      } catch (e) {
                        console.error(e);
                      }

                    } else if (clickedData['contentExtn'] == 'mp3') {
                      let blob = new Blob([data.body], { type: "audio/mpeg" });
                      let url = URL.createObjectURL(blob);
                      let audio = <HTMLAudioElement>document.getElementById('audio');
                      audio.src = url;
                      audio.crossOrigin = 'anonymous';
                      audio.load();
                      audio.play();
                    } else if (clickedData['contentExtn'] == 'jpg' || clickedData['contentExtn'] == 'jpeg' ||
                      clickedData['contentExtn'] == 'png' || clickedData['contentExtn'] == 'JPG' ||
                      clickedData['contentExtn'] == 'PNG' || clickedData['contentExtn'] == 'JPEG') {
                      let blob = new Blob([data.body], { type: "image/*" });
                      let url = URL.createObjectURL(blob);
                      let image: any = document.getElementById("picture");
                      image.src = url;
                    } else if (clickedData.contentExtn == 'pdf' ||
                      clickedData.contentExtn == 'docx' ||
                      clickedData.contentExtn == 'xlsx' ||
                      clickedData.contentExtn == 'ppt' ||
                      clickedData.contentExtn == 'pptx') {
                      let obj = {
                        trainingId: clickedData['trainingId'],
                        version: clickedData['version'],
                        contentId: clickedData['contentId'],
                        status: this.trainingData['trainingStatus'],
                        contentExtn: clickedData['contentExtn']
                      }
                      this.appService.getDocumentsToViewForLaunch(obj)
                        .subscribe((data: any) => {
                          let contentType = data.headers.get('content-type');
                          this.viewerData = {
                            body: data.body,
                            contentType: contentType,
                            extn: clickedData['contentExtn']
                          }
                        })
                    }
                  let dataSave1: any = {};
                  dataSave1.userTrainingId = this.trainingData['userTrainingId'];
                  dataSave1.contentId = clickedData['contentId'];
                  dataSave1.contentSeq = clickedData['contentSeq']
                  dataSave1.action = 'START';

                  if (this.previousContentSeq != null && this.previoustrainingContentId != null) {
                    dataSave1.action = 'END';
                    dataSave1.contentId = this.previoustrainingContentId;
                    dataSave1.contentSeq = this.previousContentSeq;
                    this.tranningContentSave(dataSave1);
                    dataSave1.contentId = clickedData['contentId'];
                    dataSave1.contentSeq = clickedData['contentSeq'];
                    dataSave1.action = 'START';
                    this.tranningContentSave(dataSave1);
                  } else {
                    this.tranningContentSave(dataSave1);
                  }
                  this.previoustrainingContentId = clickedData['contentId'];
                  this.previousContentSeq = clickedData['contentSeq'];

                  if (this.previousContentSeq == this.contentList.length) {
                    this.copmletedisplay = true;
                  } else {
                    this.copmletedisplay = false;
                  }
                  this.counterVariable = this.counterVariable + 1;

                })
            }

          })
      } else {
        let obj = {
          trainingId: this.trainingData['trainingId'],
          version: this.trainingData['version'],
          contentId: clickedData['contentId'],
          status: this.trainingData['status'],
          contentExtn: clickedData['contentExtn']
        }
        this.appService.getDocumentsToViewForLaunch(obj)
          .subscribe((data: any) => {
            if (clickedData['contentExtn'] == 'txt' || clickedData['contentExtn'] == 'TXT') {
              let blob = new Blob([data.body], { type: 'text/plain' });
              let url = URL.createObjectURL(blob);
              let iframee: any = document.getElementById("myIframe");
              iframee.oncontextmenu = function () { return false; };
              iframee.src = url + "#toolbar=0";
            } else
              if (clickedData['contentExtn'] == 'mp4') {
                console.log("clickedData['contentExtn']1=", clickedData['contentExtn']);
                try {
                  let blob = new Blob([data.body], { type: "video/mp4" });
                  let url = URL.createObjectURL(blob);
                  console.log("url=", url);
                  let video = <HTMLVideoElement>document.getElementById('videoarea');
                  video.src = url;
                  video.style.display = "block";
                  video.load();
                  video.crossOrigin = 'anonymous';
                  video.play();
                } catch (e) {
                  console.error(e);
                }

              } else if (clickedData['contentExtn'] == 'mp3') {
                let blob = new Blob([data.body], { type: "audio/mpeg" });
                let url = URL.createObjectURL(blob);
                let audio = <HTMLAudioElement>document.getElementById('audio');
                audio.src = url;
                audio.crossOrigin = 'anonymous';
                audio.load();
                audio.play();
              } else if (clickedData['contentExtn'] == 'jpg' || clickedData['contentExtn'] == 'jpeg' ||
                clickedData['contentExtn'] == 'png' || clickedData['contentExtn'] == 'JPG' ||
                clickedData['contentExtn'] == 'PNG' || clickedData['contentExtn'] == 'JPEG') {
                let blob = new Blob([data.body], { type: "image/*" });
                let url = URL.createObjectURL(blob);
                let image: any = document.getElementById("picture");
                image.src = url;
              } else if (clickedData.contentExtn == 'pdf' ||
                clickedData.contentExtn == 'docx' ||
                clickedData.contentExtn == 'xlsx' ||
                clickedData.contentExtn == 'ppt' ||
                clickedData.contentExtn == 'pptx') {
                let obj = {
                  trainingId: clickedData['trainingId'],
                  version: clickedData['version'],
                  contentId: clickedData['contentId'],
                  status: this.trainingData['trainingStatus'],
                  contentExtn: clickedData['contentExtn']
                }
                this.appService.getDocumentsToViewForLaunch(obj)
                  .subscribe((data: any) => {
                    let contentType = data.headers.get('content-type');
                    this.viewerData = {
                      body: data.body,
                      contentType: contentType,
                      extn: clickedData['contentExtn']
                    }
                  })
              }
            let dataSave1: any = {};
            dataSave1.userTrainingId = this.trainingData['userTrainingId'];
            dataSave1.contentId = clickedData['contentId'];
            dataSave1.contentSeq = clickedData['contentSeq']
            dataSave1.action = 'START';

            if (this.previousContentSeq != null && this.previoustrainingContentId != null) {
              dataSave1.action = 'END';
              dataSave1.contentId = this.previoustrainingContentId;
              dataSave1.contentSeq = this.previousContentSeq;
              this.tranningContentSave(dataSave1);
              dataSave1.contentId = clickedData['contentId'];
              dataSave1.contentSeq = clickedData['contentSeq'];
              dataSave1.action = 'START';
              this.tranningContentSave(dataSave1);
            } else {
              this.tranningContentSave(dataSave1);
            }
            this.previoustrainingContentId = clickedData['contentId'];
            this.previousContentSeq = clickedData['contentSeq'];

            if (this.previousContentSeq == this.contentList.length) {
              this.copmletedisplay = true;
            } else {
              this.copmletedisplay = false;
            }
            this.counterVariable = this.counterVariable + 1;

          })
        //}

      }

    } else if (clickedData.isQuestionContent == "Y" && clickedData.status == 'Completed' || clickedData.status == 'Passed' || clickedData.status == 'Failed') {
      this.quizdisplay = true;
      this.quizName = clickedData['contentName'];
      this.assessmentDataForQuestions = clickedData;
      this.isCompletedPage = true;
      this.isPreviewPage = false;
      this.isStartPageOfAssessment = false;
      this.isDisplayOfQuestionsPages = false;

      this.appService.getQuestionListForLaunch(clickedData['trainingId'],
        clickedData['version'], clickedData['contentId'], this.trainingData['userTrainingId'], false).subscribe((data: any) => {
          let temp = 0;
          let questionCounter = 0;

          for (let i = 0; i < data.length; i++) {
            if (temp == 0) {
              if (data[i].selectedAnswer == null || data[i].selectedAnswer == "") {
                questionCounter = i;
                temp++;
              }
            }
          }
          this.questions(data);
          this.questionDataOfAssessment = data;
          this.appService.getquestionDetailForLaunch(this.trainingData['userTrainingId'], clickedData['contentId'])
            .subscribe((data: any) => {
              this.correctAnse = [];
              this.quizdisplayfpr = [];
              this.noofCorrectAnsw = 0;
              this.noofWrongAnsw = 0;
              for (let k = 0; k < this.questionDataOfAssessment.length; k++) {
                for (let i = 0; i < data.length; i++) {
                  if (this.questionDataOfAssessment[k].questionId == data[i].questionId) {
                    this.quizdisplayfpr.push(data[i]);
                  }
                }
              }
              for (let i = 0; i < this.quizdisplayfpr.length; i++) {
                if (this.quizdisplayfpr[i].assessmentStatus == 'Correct') {
                  this.noofCorrectAnsw = this.noofCorrectAnsw + 1;
                } else if (this.quizdisplayfpr[i].assessmentStatus == 'Wrong') {
                  this.noofWrongAnsw = this.noofWrongAnsw + 1;
                }
              }

              this.newNum = (this.noofCorrectAnsw / clickedData.noOfQuestionsForAssessment) * 100;
              this.scoreperc = Number(parseFloat(this.newNum).toFixed(2))
            })
        })
      let dataSave1: any = {};
      dataSave1.userTrainingId = this.trainingData['userTrainingId'];
      dataSave1.contentId = clickedData['contentId'];
      dataSave1.contentSeq = clickedData['contentSeq']
      dataSave1.action = 'START';

      if (this.previousContentSeq != null && this.previoustrainingContentId != null) {
        dataSave1.action = 'END';
        dataSave1.contentId = this.previoustrainingContentId;
        dataSave1.contentSeq = this.previousContentSeq;
        this.tranningContentSave(dataSave1);
        dataSave1.contentId = clickedData['contentId'];
        dataSave1.contentSeq = clickedData['contentSeq'];
        dataSave1.action = 'START';
        this.tranningContentSave(dataSave1);
      } else {
        this.tranningContentSave(dataSave1);
      }
      this.previoustrainingContentId = clickedData['contentId'];
      this.previousContentSeq = clickedData['contentSeq'];

      if (this.previousContentSeq == this.contentList.length) {
        this.copmletedisplay = true;
      } else {
        this.copmletedisplay = false;
      }
      this.noOfAttemptsLeft = 0;
      if (this.trainingData.failedAttempts != null && this.trainingData.failedAttempts != 0 && this.trainingData.failedAttempts != undefined) {
        this.noOfAttempt = this.trainingData.failedAttempts;
        if (clickedData.assessmentAttempt != null && clickedData.assessmentAttempt != 0) {
          let kk = this.noOfAttempt - clickedData.assessmentAttempt;
          this.noOfAttemptsLeft = kk;
        }
      }
    } else {

      this.assessmentDataForQuestions = clickedData;
      let dataSave1: any = {};
      dataSave1.userTrainingId = this.trainingData['userTrainingId'];
      dataSave1.contentId = clickedData.contentId;
      dataSave1.contentSeq = clickedData.contentSeq;
      dataSave1.action = 'START';

      if (this.previousContentSeq != null && this.previoustrainingContentId != null) {
        dataSave1.action = 'END';
        dataSave1.contentId = this.previoustrainingContentId;
        dataSave1.contentSeq = this.previousContentSeq;
        this.tranningContentSave(dataSave1);
        dataSave1.contentId = clickedData.contentId;
        dataSave1.contentSeq = clickedData.contentSeq;
        dataSave1.action = 'START';
        this.tranningContentSave(dataSave1);
      } else {
        this.tranningContentSave(dataSave1);
      }
      this.previoustrainingContentId = clickedData.contentId;
      this.previousContentSeq = clickedData.contentSeq;
      if (this.previousContentSeq == this.contentList.length) {
        this.copmletedisplay = true;
      } else {
        this.copmletedisplay = false;
      }
      this.quizdisplay = true;

      this.appService.getQuestionListForLaunch(clickedData['trainingId'],
        clickedData['version'], clickedData['contentId'], this.trainingData['userTrainingId'], false).subscribe((data: any) => {
          if (data.length == 0) {
            interval(10000).subscribe(x => {
              this.appService.getQuestionListForLaunch(clickedData['trainingId'],
                clickedData['version'], clickedData['contentId'], this.trainingData['userTrainingId'], true).subscribe((data: any) => {
                  let questionData = [];
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].selectedAnswer != null) {
                      questionData.push(data[i]);
                    }
                  }
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].selectedAnswer == null) {
                      questionData.push(data[i]);
                    }
                  }
                  let temp = 0;
                  let temp1 = 0;
                  this.questionCounter = 0;
                  this.questions(questionData);
                  for (let i = 0; i < questionData.length; i++) {
                    if (temp == 0) {
                      if (questionData[i].selectedAnswer == null || questionData[i].selectedAnswer == "") {
                        this.questionCounter = i;
                        temp++;
                      } else {
                        temp1++;
                      }
                    }
                  }
                  if (temp1 == questionData.length) {
                    if (temp1 == 0) {
                      this.isStartPageOfAssessment = true;
                      this.isRetackAllowViewContent = true;
                    } else {
                      this.questionCounter = questionData.length - 1;

                    }
                  }
                  if (temp1 == 0 && temp1 != questionData.length) {
                    this.isStartPageOfAssessment = true;
                    this.isRetackAllowViewContent = true;
                  } else {
                    this.isRetackAllowViewContent = false;
                    this.questionDataOfAssessment = questionData;
                    this.isDisplayOfQuestionsPages = true;
                  }
                })
            });
          } else {
            let questionData = [];
            for (let i = 0; i < data.length; i++) {
              if (data[i].selectedAnswer != null) {
                questionData.push(data[i]);
              }
            }
            for (let i = 0; i < data.length; i++) {
              if (data[i].selectedAnswer == null) {
                questionData.push(data[i]);
              }
            }
            let temp = 0;
            let temp1 = 0;
            this.questionCounter = 0;
            for (let i = 0; i < questionData.length; i++) {
              if (temp == 0) {
                if (questionData[i].selectedAnswer == null || questionData[i].selectedAnswer == "") {
                  this.questionCounter = i;
                  temp++;
                } else {
                  temp1++;
                }
              }
            }
            if (temp1 == questionData.length) {
              if (temp1 == 0) {
                this.isStartPageOfAssessment = true;
                this.isRetackAllowViewContent = true;
              } else {
                this.questionCounter = questionData.length - 1;
              }
            }
            if (temp1 == 0 && temp1 != questionData.length) {
              this.isStartPageOfAssessment = true;
              this.isRetackAllowViewContent = true;
            } else {
              this.isRetackAllowViewContent = false;
              this.questionDataOfAssessment = questionData;
              this.isDisplayOfQuestionsPages = true;
            }
          }

        })


      this.quizName = clickedData.contentName;
      this.isPreviewPage = false;
    }
    if (this.varForTickMark == 1) {
      this.previousdisplay = true;
      this.firstdisplay = true;
      if (this.varForTickMark == this.contentList.length) {
        this.copmletedisplay = true;
      } else {
        this.copmletedisplay = false;
      }
    } else if (this.varForTickMark >= 2) {
      this.firstdisplay = false;
      this.previousdisplay = false;
      if (this.varForTickMark == this.contentList.length) {
        this.copmletedisplay = true;
      } else {
        this.copmletedisplay = false;
      }

    }
    this.noOfAttemptsLeft = 0;
    if (this.trainingData.failedAttempts != null && this.trainingData.failedAttempts != 0 && this.trainingData.failedAttempts != undefined) {
      this.noOfAttempt = this.trainingData.failedAttempts;
      if (clickedData.assessmentAttempt != null && clickedData.assessmentAttempt != 0) {
        let kk = this.noOfAttempt - clickedData.assessmentAttempt;
        this.noOfAttemptsLeft = kk;
      }
    }

  }
  modal: any;
  questions(data: any) {
    this.questions = data;
    this.modal = document.getElementById("myModal") as HTMLInputElement;


  }

  x: any;
  tranningContentSave(data: any) {
    if (data.isRetake) {
      this.previFirst = false;
    }
    if (!this.previFirst) {
      this.appService.trainingContentAction(data).subscribe((response: any) => {
       if (response.resultType === "S") {
          // 1. Clear existing timer if it is running
          if (this.x) {
            clearInterval(this.x);
          }
          this.distance = 0;

          let durationInMs = 0;
          const dbVal = parseFloat(response.waitTime || '0');
          const totalMins = parseFloat(this.clickedContent?.waitTimeInMins || '0');

          // 2. 🌟 SMART UNIT DETECTION: Is dbVal in SECONDS or MINUTES?
          // Condition A: If dbVal > totalMins (e.g., 57 > 1), it is SECONDS.
          // Condition B: If dbVal !== totalMins and module is 'In Progress', it is SECONDS.
          // Condition C: If clickedContent already has a saved remWaitTime > 0, it is SECONDS.
          const isSeconds =
            dbVal > totalMins ||
            (dbVal !== totalMins && dbVal > 0 && this.clickedContent?.status === 'In Progress') ||
            (this.clickedContent?.remWaitTime != null && this.clickedContent.remWaitTime > 0);

          if (isSeconds && dbVal > 0) {
            // Treat as SECONDS (e.g., 57 sec -> 57,000 ms)
            durationInMs = Math.round(dbVal * 1000);
            console.log(`[Timer] Resuming from saved SECONDS: ${dbVal}s (${durationInMs}ms)`);
          } else if (totalMins > 0) {
            // Treat as MINUTES (e.g., 1 min -> 60,000 ms)
            durationInMs = Math.round(totalMins * 60 * 1000);
            console.log(`[Timer] Starting fresh from MINUTES: ${totalMins}m (${durationInMs}ms)`);
          } else {
            durationInMs = 0;
          }

          // 3. Update UI Flags immediately
          this.isTimerActive = true;
          this.cdr.detectChanges();

          // 4. Wrap DOM access in setTimeout to wait for the element to render
          setTimeout(() => {
            const timerVal: any = document.getElementById('timers1');

            if (durationInMs <= 0) {
              if (timerVal) timerVal.innerHTML = " ";
              this.isMinimumTimeCompleted = true;
              this.isTimerActive = true;
              this.cdr.detectChanges();
            } else {
              this.isMinimumTimeCompleted = false;
              this.isTimerActive = true;
              this.cdr.detectChanges();

              let now1: any = new Date();
              now1.setTime(now1.getTime() + durationInMs); // Add duration to get the target end time
              let now2: any = new Date();

              // Initial display
              this.distance = now1.getTime() - now2.getTime();
              this.updateTimerDisplay(timerVal, this.distance);

              // Start Interval
              this.x = setInterval(() => {
                now2 = new Date();
                this.distance = now1.getTime() - now2.getTime();

                // Re-fetch element in case DOM refreshed
                const currentTimerVal = document.getElementById('timers1');
                this.updateTimerDisplay(currentTimerVal, this.distance);

                if (this.distance <= 0) {
                  clearInterval(this.x);
                  if (currentTimerVal) currentTimerVal.innerHTML = "0 min";
                  this.isMinimumTimeCompleted = true;
                  this.isTimerActive = true;
                  this.cdr.detectChanges();
                }
              }, 1000);
            }
          }, 50);

        } else {
          // Error Handling
          this.isTimerActive = true;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: response.result,
              type: response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }

        // Refresh Content List
        this.appService.getContentsListForLaunch(
          this.trainingData['trainingId'],
          this.trainingData['version'],
          this.trainingData['userTrainingId']
        ).subscribe((data: any) => {
          this.contentList = data;
          this.getContentListAndCalculateProgress(this.contentList);
          const allCompleted = this.contentList.every((c: any) => c.status === "Completed");
          this.copmletedisplayForAssessment = allCompleted;
        });
      });
    }
  }
  ngOnDestroy() {
    // 🌟 Save remaining time to DB BEFORE clearing the interval and destroying the component
    this.saveRemainingWaitTime(true);

    if (this.x) {
      clearInterval(this.x);
    }
  }

  // Helper function to update the timer text safely
  updateTimerDisplay(element: any, distance: number) {
    if (!element) return;
    try {
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      element.innerHTML = minutes + " min " + seconds + " sec ";
    } catch (ex) {
      console.log(ex);
    }
  }

  openForPreview(event: any, content: any) {
    this.currentContent = content.contentSeq;
    this.content = content;
    if (content.isQuestionContent == "Y") {
      this.appService.getContentAssessmentList(content['trainingId'],
        content['version'], content['contentId']).subscribe((data: any) => {
          content.questionsList = data;
          for (let i = 0; i < data.length; i++) {
            this.getOptionsForQuestion(data[i], content);
          }

        })
    } else {
      let obj = {
        trainingId: this.trainingData['trainingId'],
        version: this.trainingData['version'],
        contentId: content['contentId'],
        status: this.trainingData['status'],
        contentExtn: content['contentExtn']
      }
      this.appService.getDocumentsToViewForLaunch(obj)
        .subscribe((data: any) => {
          if (content['contentExtn'] == 'pdf') {
            let blob = new Blob([data], { type: 'application/pdf' });
            let url = URL.createObjectURL(blob);
            let iframee: any = document.getElementById("myIframe");
            iframee.oncontextmenu = function () { return false; };
            iframee.src = url + "#toolbar=0";
          } else if (content['contentExtn'] == 'mp4') {
            let blob = new Blob([data], { type: "video/mp4" });
            let url = URL.createObjectURL(blob);
            let video = <HTMLVideoElement>document.getElementById('videoarea');
            video.src = url;
            video.style.display = "block";
            video.load();
          }
        })
    }
  }

  closePreview() {
    let isAllCompleted = false;
    if (this.contentList[this.varForTickMark - 1].contentSeq == this.contentList.length &&
      (this.contentList[this.varForTickMark - 1].assessmentStatus == "Completed" || this.contentList[this.varForTickMark - 1].assessmentStatus == "Passed")) {
      if (this.trainingData.levelStatus != "Completed") {
        this.visibleCloseOfLaunchPage = this.dialog.open(this.closeOfLaunchPage, this.closeOfLaunchPageConfig);
      } else {
        if (this.distance == 0 || this.distance < 0) {
          this.saveRemainingWaitTime(false);
          this.appService.setTrainingDetails(null, this.trainingData);
          clearInterval(this.x);
          this.router.navigate(['/dashboard/trainingDashboardDetail'])
        } else {
          alert("Please wait until you have completed your minimum training time.");
        }

      }
    } else {
      if (this.distance == 0 || this.distance < 0) {
        this.saveRemainingWaitTime(false);
        this.appService.setTrainingDetails(null, this.trainingData);
        clearInterval(this.x);
        this.router.navigate(['/dashboard/trainingDashboardDetail'])
      } else {
        alert("Please wait until you have completed your minimum training time.");
      }
    }
  }

  public currentContent: any;
  firstdisplay: boolean = false;
  previousdisplay: boolean = false;
  copmletedisplay: boolean = false;
  isStartPageOfAssessment: boolean = false;
  isCompletedPage: boolean = false;
  clickedContent: any;
  quizName = "";
  noOfAttemptsLeft = 0;
  previFirst: boolean = false;
  alertShow: boolean = false;
  isRetackAllowViewContent: boolean = false;
  playfirst() {
    if (this.distance == 0 || this.distance < 0) {
      this.previFirst = !this.isRetakeActive; this.alertShow = false;

      this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
        this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
          this.contentList = data;

          this.getContentListAndCalculateProgress(this.contentList);
          if (this.contentList[this.varForTickMark - 1].isQuestionContent == "Y") {
            if (this.contentList[this.varForTickMark - 1].status == "Passed" || this.contentList[this.varForTickMark - 1].status == "Completed" ||
              this.contentList[this.varForTickMark - 1].status == "Failed") {
              this.previousdisplay = true;
              if (this.contentList !== undefined) {
                this.getContentDataForLaunch(this.contentList[0]);
              }
            } else {
              this.alertMsg = "Please complete the assessment to move to next content";
              this.alertShow = true;

            }
          } else {
            this.previousdisplay = true;
            if (this.contentList !== undefined) {
              this.getContentDataForLaunch(this.contentList[0]);
            }
          }

        })
    } else {
      alert("Please wait until you have completed your minimum training time.");
    }

  }

  playback() {
    if (this.distance == 0 || this.distance < 0) {
      this.previFirst = !this.isRetakeActive; this.alertShow = false;

      this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
        this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
          this.contentList = data;

          this.getContentListAndCalculateProgress(this.contentList);
          if (this.contentList[this.varForTickMark - 1].isQuestionContent == "Y") {
            if (this.contentList[this.varForTickMark - 1].status == "Passed" || this.contentList[this.varForTickMark - 1].status == "Completed" || this.contentList[this.varForTickMark - 1].status == "Failed"
            ) {
              this.isPreviewPage = true;
              if (this.contentList !== undefined) {
                if (this.previousContentSeq > 0) {
                  if (this.previousContentSeq != null) {
                    this.counterVariable = this.previousContentSeq - 2;
                    this.getContentDataForLaunch(this.contentList[this.counterVariable]);
                  }
                }
              }

              this.isDisplayOfQuestionsPages = false;
              this.isCompletedPage = false;
              this.isPreviewPage = false;
            } else {
              this.alertMsg = "Please complete the assessment to move to the next content";
              this.alertShow = true;
            }
          } else {
            this.isPreviewPage = false;
            if (this.contentList !== undefined) {
              if (this.previousContentSeq > 0) {
                if (this.previousContentSeq != null) {
                  this.counterVariable = this.previousContentSeq - 2;
                  this.getContentDataForLaunch(this.contentList[this.counterVariable]);
                }
              }
            }
          }

        })
    } else {
      alert("Please wait until you have completed your minimum training time.");
    }
  }
  distance: number = 0;
  playLast() {
    if (this.distance == 0 || this.distance < 0) {
      this.previFirst = false;


      this.alertShow = false;

      this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
        this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
          this.contentList = data;

          this.getContentListAndCalculateProgress(this.contentList);
          if (this.contentList[this.varForTickMark - 1].isQuestionContent == "Y") {
            if (this.contentList[this.varForTickMark - 1].status == "Passed" || this.contentList[this.varForTickMark - 1].status == "Completed"
            ) {
              let dataSave1: any = {};
              dataSave1.userTrainingId = this.trainingData['userTrainingId'];
              if (this.previousContentSeq != null && this.previoustrainingContentId != null) {
                dataSave1.action = 'END';
                dataSave1.contentId = this.previoustrainingContentId;
                dataSave1.contentSeq = this.previousContentSeq;
                this.tranningContentSave(dataSave1);
                for (let i = 0; i < this.contentList.length; i++) {
                  if (this.contentList[i].status != "Completed") {
                    this.previousContentSeq = i + 1;
                    let k = i;
                    i = this.contentList.length;
                    this.getContentDataForLaunch(this.contentList[k]);
                  }
                }
                if (this.previousContentSeq >= 1) {
                } else {
                  this.getContentDataForLaunch(this.contentList[this.contentList.length - 1]);
                }
              }

            } else {
              this.alertMsg = "Please complete the assessment to move to the next content";
              this.alertShow = true;
              if (this.contentList[this.varForTickMark - 1].status == "Failed") {
                this.goBack();
              }
            }
          } else {
            let dataSave1: any = {};
            dataSave1.userTrainingId = this.trainingData['userTrainingId'];
            if (this.previousContentSeq != null && this.previoustrainingContentId != null) {
              dataSave1.action = 'END';
              dataSave1.contentId = this.previoustrainingContentId;
              dataSave1.contentSeq = this.previousContentSeq;
              this.tranningContentSave(dataSave1);
              for (let i = 0; i < this.contentList.length; i++) {
                if (this.contentList[i].status != "Completed") {
                  this.previousContentSeq = i + 1;
                  let k = i;
                  i = this.contentList.length;
                  this.getContentDataForLaunch(this.contentList[k]);
                }
              }
              if (this.previousContentSeq >= 1) {
              } else {
                this.getContentDataForLaunch(this.contentList[this.contentList.length - 1]);
              }
            }
          }



        })

    } else {
      alert("Please wait until you have completed your minimum training time.");
    }
  }

  playnext(data: any) {
    if (this.distance == 0 || this.distance < 0) {
      // Don't set previFirst = false here yet. We decide based on the *next* content status.

      this.alertShow = false;

      this.appService.getContentsListForLaunch(
        this.trainingData['trainingId'],
        this.trainingData['version'],
        this.trainingData['userTrainingId']
      ).subscribe((data: any) => {
        this.contentList = data;

        this.getContentListAndCalculateProgress(this.contentList);

        // Check if current content is a question and passed/completed
        if (this.contentList[this.varForTickMark - 1].isQuestionContent == "Y") {
          if (this.contentList[this.varForTickMark - 1].status == "Passed" ||
            this.contentList[this.varForTickMark - 1].status == "Completed") {

            if (this.contentList !== undefined) {
              if (this.previousContentSeq < this.contentList.length) {
                if (this.previousContentSeq != null) {
                  this.counterVariable = this.previousContentSeq;
                }

                // --- NEW LOGIC START ---
                let nextContent = this.contentList[this.counterVariable];
                if (nextContent.status == 'Completed' || nextContent.status == 'Passed') {
                  // If Retake is Active, previFirst is FALSE (Timer Runs)
                  // If Retake is INACTIVE (after submit), previFirst is TRUE (Timer Skips)
                  this.previFirst = !this.isRetakeActive;
                } else {
                  // If content is not completed, Always Run Timer
                  this.previFirst = false;
                }
                // --- NEW LOGIC END ---

                this.getContentDataForLaunch(this.contentList[this.counterVariable]);
              }
            }
            this.isDisplayOfQuestionsPages = false;
            this.isCompletedPage = false;
            this.isPreviewPage = false;
          } else {
            this.alertMsg = "Please complete the assessment to move to the next content";
            this.alertShow = true;
            if (this.contentList[this.varForTickMark - 1].status == "Failed") {
              this.goBack();
            }
          }
        } else {
          // Logic for Non-Question Content
          if (this.previousContentSeq != null) {
            this.counterVariable = this.previousContentSeq;
          }

          // --- NEW LOGIC START ---
          let nextContent = this.contentList[this.counterVariable];
          if (nextContent.status == 'Completed' || nextContent.status == 'Passed') {
            this.previFirst = !this.isRetakeActive;
          } else {
            this.previFirst = false;
          }
          // --- NEW LOGIC END ---

          this.getContentDataForLaunch(this.contentList[this.counterVariable]);
        }

      });
    } else {
      alert("Please wait until you have completed your minimum training time.");
    }
  }
  pass: any;
  passRequiredMsg: any;
  reject: any;
  rejectReq: any;
  buttonOperationFieldValidation() {
    //
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    this.reject = document.getElementById('rejectReason') as HTMLInputElement;
    this.rejectReq = document.getElementById('reasonFor-required-msg') as HTMLInputElement;

    if (this.password == "") {
      this.pass.style.border = '1px solid red';
      this.passRequiredMsg.style.display = 'block';
    } else {
      this.pass.style.border = 'none';
      this.passRequiredMsg.style.display = 'none';
    }
    if (!this.reasonForSign || this.reasonForSign === "") {
      this.reject.style.border = '1px solid red';
      this.rejectReq.style.display = 'block';
    } else {
      this.reject.style.border = 'none';
      this.rejectReq.style.display = 'none';
    }
  }
  confirmCompleteCall() {
    this.previFirst = false;
    this.isRetakeActive = false;

    // START LOADER
    this.globalLoader.show();

    let dataSave1: any = {};
    dataSave1.userTrainingId = this.trainingData['userTrainingId'];
    dataSave1.action = 'END';
    dataSave1.contentId = this.clickedContent.contentId;
    dataSave1.contentSeq = this.clickedContent.contentSeq;

    this.appService.trainingContentAction(dataSave1).subscribe(
      (data: any) => {
        if (data.resultType == "S") {
          // DIRECT TO COMPLETION (Bypassing Certificates)
          this.executeFinalCompletion();
        } else {
          this.globalLoader.hide();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: { message: data.result, type: 'Error', buttonLabel: "Ok" },
            horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'Error',
          });
          sb.onAction().subscribe(() => { sb.dismiss(); });
        }
      },
      (error) => {
        this.globalLoader.hide();
      }
    );
  }
  executeFinalCompletion() {
    let dataSave: any = {};
    dataSave.userTrainingId = this.trainingData['userTrainingId'];
    dataSave.reasonForSignature = this.reasonForSign ?? null;
    dataSave.filePath = null;
    dataSave.fileNme = null;

    this.appService.completeTraining(dataSave).subscribe(
      (data1: any) => {
        this.previFirst = false;

        this.globalLoader.hide();

        if (data1.resultType == "S") {
          clearInterval(this.x);
          if (this.visibleConfirmComplete) {
            this.visibleConfirmComplete.close();
          }

          this.trainingCompleteConfirmationMsg = data1.result;
          this.visibleConfirmation = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);

        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: { message: data1.result, type: 'Error', buttonLabel: "Ok" },
            horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'Error',
          });
          sb.onAction().subscribe(() => { sb.dismiss(); });
        }
      },
      (error) => {
        this.globalLoader.hide();
        console.error(error);
      }
    );
  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            this.confirmCompleteCall();
          } else {
            // console.log("outside");
          }
        },
        error: (error) => {

        }
      });
  }

  confirmComplete() {

    if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("adenabele")
    }
    else if (this.password == "" || (!this.reasonForSign || this.reasonForSign === "")) {
      this.buttonOperationFieldValidation();

    } else {
      this.globalLoader.show();
      let data = {
        userName: this.userName,
        password: this.password,
      }

      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.confirmCompleteCall();
        } else {
          this.globalLoader.hide();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }
      }, (error) => {
        this.globalLoader.hide(); // STOP ON ERROR
      })
    }
  }

  completetraining(data: any) {
    if (this.distance == 0 || this.distance < 0) {

      if (this.isEsignRequired) {
        this.password = '';
        this.visibleConfirmComplete = this.dialog.open(this.confirmCompletePopup, this.confirmCompletePopupConfig);
      } else {
        this.previFirst = false;

        // START LOADER
        this.globalLoader.show();

        let dataSave1: any = {};
        dataSave1.userTrainingId = this.trainingData['userTrainingId'];
        dataSave1.action = 'END';
        dataSave1.contentId = this.clickedContent.contentId;
        dataSave1.contentSeq = this.clickedContent.contentSeq;

        this.appService.trainingContentAction(dataSave1).subscribe(
          (data: any) => {
            if (data.resultType == "S") {
              // DIRECT TO COMPLETION (Bypassing Certificates)
              this.executeFinalCompletion();
            } else {
              this.globalLoader.hide();
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: { message: data.result, type: 'Error', buttonLabel: "Ok" },
                horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'Error',
              });
              sb.onAction().subscribe(() => { sb.dismiss(); });
            }
          });
      }
    } else {
      alert("Please wait until you have completed your minimum training time.");
    }
  }
  maxAllowedAttempt = 5;
  noOfAttempt: any;
  isDisplayOfQuestionsPages = false;
  startTheTest() {

    if (this.distance > 0) {
      alert("Please wait until you have completed your minimum training time.");
      return;
    }
    this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
      this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
        this.isDisplayOfQuestionsPages = true;
        this.contentList = data;

        this.getContentListAndCalculateProgress(this.contentList);
        if (this.contentList[this.varForTickMark - 1].assessmentAttempt != null && this.trainingData.failedAttempts != null) {
          this.noOfAttemptsLeft = 0;
          if (this.trainingData.failedAttempts != null && this.trainingData.failedAttempts != 0 && this.trainingData.failedAttempts != undefined) {
            this.noOfAttempt = this.trainingData.failedAttempts;
            if (this.contentList[this.varForTickMark - 1].assessmentAttempt != null && this.contentList[this.varForTickMark - 1].assessmentAttempt != 0) {
              let kk = this.noOfAttempt - this.contentList[this.varForTickMark - 1].assessmentAttempt;
              this.noOfAttemptsLeft = kk;
            }
          }
          this.alertShow = false;
          this.isStartPageOfAssessment = false;

          this.appService.getQuestionListForLaunch(this.clickedContent['trainingId'],
            this.clickedContent['version'], this.clickedContent['contentId'], this.trainingData['userTrainingId'], false).subscribe((data: any) => {
              let temp = 0;
              this.questionCounter = 0;
              for (let i = 0; i < data.length; i++) {
                if (temp == 0) {
                  if (data[i].answer == null || data[i].answer == "") {
                    this.questionCounter = i;
                    temp++;
                  }
                }
              }
              this.questionDataOfAssessment = data;

            })
        } else {
          this.noOfAttemptsLeft = 0;

          this.alertShow = false;
          this.isStartPageOfAssessment = false;

          this.appService.getQuestionListForLaunch(this.clickedContent['trainingId'],
            this.clickedContent['version'], this.clickedContent['contentId'], this.trainingData['userTrainingId'], false).subscribe((data: any) => {
              let temp = 0;
              this.questionCounter = 0;
              for (let i = 0; i < data.length; i++) {
                if (temp == 0) {
                  if (data[i].selectedAnswer == null || data[i].selectedAnswer == "") {
                    this.questionCounter = i;
                    temp++;
                  }
                }
              }
              this.questionDataOfAssessment = data;

            })

        }

      });
  }

  goBack() {
    this.previFirst = true;
    this.isCompletedPage = true;
    this.isPreviewPage = false;
    this.quizdisplay = false;
    this.pdfdisplay = false;
    this.varForTickMark = this.clickedContent.contentSeq;
    this.videodisplay = false;
    this.quizdisplay = true;
    this.quizName = this.clickedContent.contentName;
    this.assessmentDataForQuestions = this.clickedContent;
    this.isCompletedPage = true;
    this.isPreviewPage = false;

    this.appService.getQuestionListForLaunch(this.clickedContent['trainingId'],
      this.clickedContent['version'], this.clickedContent['contentId'], this.trainingData['userTrainingId'], false).subscribe((data: any) => {
        let temp = 0;
        this.questionCounter = 0;
        for (let i = 0; i < data.length; i++) {
          if (temp == 0) {
            if (data[i].selectedAnswer == null || data[i].selectedAnswer == "") {
              this.questionCounter = i;
              temp++;
            }
          }

        }

        this.questionDataOfAssessment = data;
        this.appService.getquestionDetailForLaunch(this.trainingData['userTrainingId'], this.clickedContent['contentId'])
          .subscribe((data: any) => {
            this.correctAnse = [];
            this.quizdisplayfpr = [];
            this.noofCorrectAnsw = 0;
            this.noofWrongAnsw = 0;
            for (let k = 0; k < this.questionDataOfAssessment.length; k++) {
              for (let i = 0; i < data.length; i++) {
                if (this.questionDataOfAssessment[k].questionId == data[i].questionId) {
                  this.quizdisplayfpr.push(data[i]);
                }
              }
            }
            for (let i = 0; i < this.quizdisplayfpr.length; i++) {
              if (this.quizdisplayfpr[i].assessmentStatus == 'Correct') {
                this.noofCorrectAnsw = this.noofCorrectAnsw + 1;
              } else if (this.quizdisplayfpr[i].assessmentStatus == 'Wrong') {
                this.noofWrongAnsw = this.noofWrongAnsw + 1;
              }
            }

            this.newNum = (this.noofCorrectAnsw / this.assessmentDataForQuestions.noOfQuestionsForAssessment) * 100;
            this.scoreperc = Number(parseFloat(this.newNum).toFixed(2))

          });
      })


    this.previoustrainingContentId = this.clickedContent.trainingContentId;
    this.previousContentSeq = this.clickedContent.contentSeq;
    if (this.previousContentSeq == this.contentList.length) {
      this.copmletedisplay = true;
    } else {
      this.copmletedisplay = false;
    }


  }


  getmoiveLeftMenuUrl(content: any, index: any) {
    if (this.distance == 0 || this.distance < 0) {


      this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
        this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
          this.contentList = data;

          this.getContentListAndCalculateProgress(this.contentList);
          if (this.contentList[this.varForTickMark - 1].isQuestionContent == "Y") {
            if (this.contentList[this.varForTickMark - 1].status == "Passed" || this.contentList[this.varForTickMark - 1].status == "Completed" || this.contentList[this.varForTickMark - 1].status == "Failed"
            ) {


              if (content.status == 'Completed') {
                this.previFirst = !this.isRetakeActive;
                this.getContentDataForLaunch(this.contentList[index]);

              }


            } else {
              this.alertMsg = "Please complete the assessment to move to the next content";
              this.alertShow = true;

            }
          } else {


            if (content.status == 'Completed') {
              this.previFirst = !this.isRetakeActive; this.getContentDataForLaunch(this.contentList[index]);

            }
          }

        })
    } else {
      alert("Please wait until you have completed your minimum training time.");
    }

  }

  imageClick(image: any) {

  }

  copmletedisplayForAssessment = false;
  onAllSubmit(answers: any) {
    this.answers = answers
    this.appService.getQuestionListForLaunch(this.clickedContent['trainingId'],
      this.clickedContent['version'], this.clickedContent['contentId'], this.trainingData['userTrainingId'], false).subscribe((data: any) => {
        let allAnswerselected = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].selectedAnswer != null && data[i].selectedAnswer != "") {
            allAnswerselected++;
          }
        }
        if (allAnswerselected == data.length) {

          this.appService.getquestionDetailForLaunch(this.trainingData['userTrainingId'], this.clickedContent['contentId'])
            .subscribe((data: any) => {

              this.isRetakeActive = false;
              this.correctAnse = [];
              this.quizdisplayfpr = [];
              this.noofCorrectAnsw = 0;
              this.noofWrongAnsw = 0;
              for (let k = 0; k < this.questionDataOfAssessment.length; k++) {
                for (let i = 0; i < data.length; i++) {
                  if (this.questionDataOfAssessment[k].questionId == data[i].questionId) {
                    this.quizdisplayfpr.push(data[i]);
                  }
                }
              }
              for (let i = 0; i < this.quizdisplayfpr.length; i++) {
                if (this.quizdisplayfpr[i].assessmentStatus == 'Correct') {
                  this.noofCorrectAnsw = this.noofCorrectAnsw + 1;
                } else if (this.quizdisplayfpr[i].assessmentStatus == 'Wrong') {
                  this.noofWrongAnsw = this.noofWrongAnsw + 1;
                }
              }

              this.newNum = (this.noofCorrectAnsw / this.assessmentDataForQuestions.noOfQuestionsForAssessment) * 100;
              this.scoreperc = Number(parseFloat(this.newNum).toFixed(2))
              let dataSave1: any = {};
              dataSave1.userTrainingId = this.trainingData['userTrainingId'];
              dataSave1.action = 'END';
              dataSave1.contentId = this.clickedContent.contentId;
              dataSave1.contentSeq = this.previousContentSeq;
              this.tranningContentSave(dataSave1);

              this.isCompletedPage = true;
              this.isDisplayOfQuestionsPages = false;
            });
        } else {
          this.isCompletedPage = false;
          this.isDisplayOfQuestionsPages = true;

          this.visibleModalConfirmPopup = this.dialog.open(this.modalConfirmPopup, this.modalConfirmPopupConfig);
        }
      })
  }

  closeModal() {
    this.modal.style.display = "none";
  }

  noBtn() {
    this.visibleModalConfirmPopup.close();
  }

  yesBtn() {

    this.appService.getquestionDetailForLaunch(this.trainingData['userTrainingId'], this.clickedContent['contentId'])
      .subscribe((data: any) => {
        this.isRetakeActive = false;
        this.correctAnse = [];
        this.quizdisplayfpr = [];
        this.noofCorrectAnsw = 0;
        this.noofWrongAnsw = 0;
        for (let k = 0; k < this.questionDataOfAssessment.length; k++) {
          for (let i = 0; i < data.length; i++) {
            if (this.questionDataOfAssessment[k].questionId == data[i].questionId) {
              this.quizdisplayfpr.push(data[i]);
            }
          }
        }
        for (let i = 0; i < this.quizdisplayfpr.length; i++) {
          if (this.quizdisplayfpr[i].assessmentStatus == 'Correct') {
            this.noofCorrectAnsw = this.noofCorrectAnsw + 1;
          } else if (this.quizdisplayfpr[i].assessmentStatus == 'Wrong') {
            this.noofWrongAnsw = this.noofWrongAnsw + 1;
          }
        }

        this.newNum = (this.noofCorrectAnsw / this.assessmentDataForQuestions.noOfQuestionsForAssessment) * 100;
        this.scoreperc = Number(parseFloat(this.newNum).toFixed(2));
        let dataSave1: any = {};
        dataSave1.userTrainingId = this.trainingData['userTrainingId'];
        dataSave1.action = 'END';
        dataSave1.contentId = this.clickedContent.contentId;
        dataSave1.contentSeq = this.previousContentSeq;
        this.tranningContentSave(dataSave1);

        this.isCompletedPage = true;
        this.isDisplayOfQuestionsPages = false;
      });
    this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
      this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
        this.contentList = data;

        this.getContentListAndCalculateProgress(this.contentList);
      })
    this.visibleModalConfirmPopup.close();
  }
  answers: any;
  questionCounter: any = 0;
  reviewAnswer() {
    this.alertShow = false;
    this.isStartPageOfAssessment = false;
    this.isDisplayOfQuestionsPages = false;
    this.isPreviewPage = true; // Set this to show the review page structure
    this.isCompletedPage = false;

    // Clear previous review data state (optional, but good practice)
    // Reset properties that are specific to the review state
    if (this.questionDataOfAssessment && Array.isArray(this.questionDataOfAssessment)) {
      this.questionDataOfAssessment.forEach((question: any) => {
        question.correctAnswer = null;
        question.assessmentStatus = null;
        // Explicitly reset option flags used in the review template
        if (question.questionOptions && Array.isArray(question.questionOptions)) {
          question.questionOptions.forEach((opt: any) => {
            opt.checked = false; // Reset UI checked state
            opt.answer = null;   // Reset UI answer binding state (null for radio, false for checkbox)
            opt.isCorrect = false; // Reset correct indicator
            opt.isIncorrect = false; // Reset incorrect indicator
          });
        }
      });
    }

    // Step 1: Fetch user's selected answers and basic question data
    this.appService.getQuestionListForLaunch1(
      this.clickedContent['trainingId'],
      this.clickedContent['version'],
      this.clickedContent['contentId'],
      this.trainingData['userTrainingId']
    ).subscribe(
      (userData: any) => {
        this.questionDataOfAssessment = userData; // This contains question.questionOptions and question.selectedAnswer

        //  Fetch correct answers and assessment status
        this.appService.getquestionDetailForLaunch(
          this.trainingData['userTrainingId'],
          this.clickedContent['contentId']
        ).subscribe(
          (correctAnswerData: any) => {
            // Process the data to update questionDataOfAssessment with user selections and correct answers/status
            this.questionDataOfAssessment.forEach((question: any) => {
              // Find the corresponding correct answer detail for this question
              const correctDetail = correctAnswerData.find(
                (detail: any) => detail.questionId === question.questionId
              );

              // Set correct answer and assessment status
              if (correctDetail) {
                question.correctAnswer = correctDetail.answer;
                question.assessmentStatus = correctDetail.assessmentStatus; // Comes from getquestionDetailForLaunch
              } else {
                // Handle case where correct detail might not be found
                question.correctAnswer = null;
                question.assessmentStatus = null;
              }

              // Now, process the user's *selected* answer for this question (from getQuestionListForLaunch1)
              const userSelectedAnswerStr = question.selectedAnswer; // This comes from userData

              // Reset option flags before setting them based on user selection and correct answer
              if (question.questionOptions && Array.isArray(question.questionOptions)) {
                question.questionOptions.forEach((opt: any) => {
                  opt.checked = false;
                  opt.answer = null; // Or false for checkboxes if that's the convention
                  opt.isCorrect = false;
                  opt.isIncorrect = false;
                });
              }


              if (userSelectedAnswerStr) { // Only process if user selected something
                const isRadio = (question.questionType === "RADIO" || question.questionType === "Radio Button");
                const isCheckbox = (question.questionType === "CHECKBOX" || question.questionType === "Check Box");

                if (isRadio) {
                  const selectedOptionCode = userSelectedAnswerStr.trim();
                  if (question.questionOptions && Array.isArray(question.questionOptions)) {
                    question.questionOptions.forEach((option: any) => {
                      if (option.optionCode === selectedOptionCode) {
                        option.checked = true; // Mark the option as selected by the user
                        option.answer = option.optionCode; // Bind this value to ngModel for radio
                      } else {
                        option.checked = false; // Ensure others are not marked as selected
                        option.answer = null; // Ensure ngModel binding is correct for others
                      }
                    });
                  }
                } else if (isCheckbox) {
                  const selectedCodesArray = userSelectedAnswerStr.split(',').map((code: any) => code.trim());
                  if (question.questionOptions && Array.isArray(question.questionOptions)) {
                    question.questionOptions.forEach((option: any) => {
                      const isSelectedByUser = selectedCodesArray.includes(option.optionCode);
                      option.checked = isSelectedByUser; // Mark as selected by the user
                      option.answer = isSelectedByUser; // Bind this boolean value to ngModel for checkbox
                    });
                  }
                } else {
                  console.warn(`Unknown question type: ${question.questionType} for question ${question.questionId}`);
                }
              } // End of if (userSelectedAnswerStr)

              // Mark correct options and incorrect user selections based on the correct answer (from getquestionDetailForLaunch)
              if (question.correctAnswer) {
                const isRadio = (question.questionType === "RADIO" || question.questionType === "Radio Button");
                const isCheckbox = (question.questionType === "CHECKBOX" || question.questionType === "Check Box");

                if (isRadio) {
                  if (question.questionOptions && Array.isArray(question.questionOptions)) {
                    question.questionOptions.forEach((option: any) => {
                      if (option.optionCode === question.correctAnswer) {
                        option.isCorrect = true; // Mark the correct option visually
                      }
                    });
                  }
                } else if (isCheckbox) {
                  const correctCodesArray = question.correctAnswer.split(',').map((code: any) => code.trim());
                  if (question.questionOptions && Array.isArray(question.questionOptions)) {
                    question.questionOptions.forEach((option: any) => {
                      if (correctCodesArray.includes(option.optionCode)) {
                        option.isCorrect = true; // Mark correct options visually
                      }
                      // Mark user's incorrect selections: user selected it (option.checked is true),
                      // but it's not in the correct answer list
                      if (option.checked && !correctCodesArray.includes(option.optionCode)) {
                        option.isIncorrect = true;
                      }
                    });
                  }
                }
              } // End of if (question.correctAnswer)
            }); // End of forEach question

            // Trigger change detection after the state is fully updated ---
            // This ensures the template re-renders with the correct 'checked' and 'answer' states
            this.cdr.detectChanges();
          }, // End of inner subscribe success
          (error) => {
            console.error("Error fetching correct answers for review:", error);
            this.cdr.detectChanges(); // Still call detectChanges to potentially reflect any partial state or errors if template handles them
          }
        ); // End of getquestionDetailForLaunch subscribe
      }, // End of outer subscribe success
      (error) => {
        console.error("Error fetching user answers for review:", error);
        // Handle error state if necessary, e.g., show an error message
        this.isPreviewPage = false; // Hide the review page if initial data fetch fails
        this.cdr.detectChanges();
      }
    ); // End of getQuestionListForLaunch1 subscribe
  }

  showRetakeTime = false;
  retakeAssessment() {
    if (this.contentList[this.varForTickMark - 1].isQuestionContent == "Y") {
      let dataSaveretack: any = {};
      dataSaveretack.userTrainingId = this.trainingData['userTrainingId'];
      dataSaveretack.contentId = this.clickedContent.contentId;

      this.appService.retakeAssessment(dataSaveretack).subscribe((data: any) => {
        if (data.resultType == "S") {
          // Explicitly open the gate for the timer!
          // If previFirst is true, tranningContentSave completely aborts and hides the timer UI.
          this.previFirst = false;
          this.isRetakeActive = true;

          // Fire START action AFTER retake is approved by the server
          let dataSave1: any = {};
          dataSave1.userTrainingId = this.trainingData['userTrainingId'];
          dataSave1.contentId = this.clickedContent.contentId;
          dataSave1.contentSeq = this.clickedContent.contentSeq;
          dataSave1.action = 'START';
          dataSave1.isRetake = true;
          this.tranningContentSave(dataSave1);

          this.alertShow = false;
          this.isCompletedPage = false;
          this.answers = [];
          this.noofCorrectAnsw = 0;
          this.noofWrongAnsw = 0;
          this.isPreviewPage = false;

          this.appService.getUserTrainingsByTrainingId(this.trainingData['userTrainingId']).subscribe((data: any) => {
            this.trainingData = data[0];
          });

          this.appService.getContentsListForLaunch(this.trainingData['trainingId'],
            this.trainingData['version'], this.trainingData['userTrainingId']).subscribe((data: any) => {
              this.contentList = data;

              if (this.contentList[this.varForTickMark - 1].assessmentAttempt == this.trainingData.failedAttempts) {
                this.noOfAttemptsLeft = 0;
              } else {
                this.noOfAttemptsLeft = 0;
                if (this.trainingData.failedAttempts != null && this.trainingData.failedAttempts != 0 && this.trainingData.failedAttempts != undefined) {
                  this.noOfAttempt = this.trainingData.failedAttempts;
                  if (this.contentList[this.varForTickMark - 1].assessmentAttempt != null && this.contentList[this.varForTickMark - 1].assessmentAttempt != 0) {
                    let kk = this.noOfAttempt - this.contentList[this.varForTickMark - 1].assessmentAttempt;
                    this.noOfAttemptsLeft = kk;
                  }
                }
              }
              // Fetch questions for the NEW retake attempt and reset their state 
              this.appService.getQuestionListForLaunch(
                this.clickedContent['trainingId'],
                this.clickedContent['version'],
                this.clickedContent['contentId'],
                this.trainingData['userTrainingId'], false
              ).subscribe(
                (questionData: any) => {
                  if (Array.isArray(questionData)) {
                    questionData.forEach((question: any) => {
                      question.selectedAnswer = null;
                      if (question.questionOptions && Array.isArray(question.questionOptions)) {
                        question.questionOptions.forEach((opt: any) => {
                          opt.checked = false;
                          opt.answer = null;
                          opt.isCorrect = false;
                          opt.isIncorrect = false;
                        });
                      }
                    });
                  }

                  this.questionDataOfAssessment = questionData;
                  this.isRetackAllowViewContent = true;
                  this.isStartPageOfAssessment = true;
                  this.cdr.detectChanges();
                },
                (error) => {
                  console.error("Error fetching questions for retake:", error)
                }
              );

              this.isStartPageOfAssessment = true;

            });
          this.isRetackAllowViewContent = true;
        } else {
          this.isTimerActive = false;
          this.cdr.detectChanges();
          if (this.trainingData.retakeAfterNMinOnFailedAttempt != null) {
            this.showRetakeTime = true;
            let now1: any = new Date();
            now1.setMinutes(now1.getMinutes() + this.trainingData.retakeAfterNMinOnFailedAttempt);
            let now2: any = new Date();
            let x = setInterval(() => {
              now2.setSeconds(now2.getSeconds() + 1);
              this.distance = now1 - now2;
              let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60));
              let seconds = Math.floor((this.distance % (1000 * 60)) / 1000);
              let timerVal: any = document.getElementById('timers2');
              this.isTimerActive = true;
              this.cdr.detectChanges();
              try {
                timerVal.innerHTML = minutes + " min " + seconds + " sec ";
              } catch (ex) {
                console.log(ex);
              }
              if (this.distance < 0) {
                clearInterval(x);
                this.showRetakeTime = false;
                timerVal.innerHTML = "0 min";
                this.isTimerActive = true;
                this.cdr.detectChanges();
              }
            }, 1000);
          }

          this.isRetackAllowViewContent = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
      })
    }
  }
  visibleCertificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('certificationPopup', { static: true }) certificationPopup: TemplateRef<any>;

  visibleCertificationPopup1: MatDialogRef<TemplateRef<any>>;
  @ViewChild('certificationPopup1', { static: true }) certificationPopup1: TemplateRef<any>;

  visibleConfirmComplete: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmCompletePopup', { static: true }) confirmCompletePopup: TemplateRef<any>;

  visibleConfirmation: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;

  visibleCloseOfLaunchPage: MatDialogRef<TemplateRef<any>>;
  @ViewChild('closeOfLaunchPage', { static: true }) closeOfLaunchPage: TemplateRef<any>;

  closeOfLaunchPageConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmCompletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };



  certificationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  };

  oneQmsOrgImagesDetails: any = {};
  orgData: any = {};
  trainingCompleteConfirmationMsg = '';
  isDefaultTemplate: boolean = false;
  isWithScoreTemplate: boolean = false;
  certificateTemplate: any = {};
  certificateData: any;

  openPopup(event: any) {
    event.preventDefault();

    this.isDefaultTemplate = false;
    this.isWithScoreTemplate = false;
    if (this.trainingData.finalScore != null || this.scoreperc != null) {
      this.appService.getTrainingCertificateTemplates().subscribe(
        (data: any) => {

          for (let i = 0; i < data.length; i++) {
            if (data[i].isDefaultWithscoreTemplate === "Y") {
              this.certificateTemplate = data[i];
              break;
            }
          }
          if (!this.certificateTemplate?.template) {
            this.isDefaultTemplate = false;
          } else {
            this.isDefaultTemplate = true;
            this.buildCertificateData(this.certificateTemplate.template);
          }
          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);


          this.visibleCertificationPopup.afterClosed().subscribe(() => {
            this.backToPageWithConfirm();
          });
        },
        (error) => {

          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);

          this.visibleCertificationPopup.afterClosed().subscribe(() => {
            this.backToPageWithConfirm();
          });
          throw error;
        }
      );
      this.isWithScoreTemplate = true;
    } else {
      this.appService.getTrainingCertificateTemplates().subscribe(
        (data: any) => {

          for (let i = 0; i < data.length; i++) {
            if (data[i].isDefaultWithoutscoreTemplate === "Y") {
              this.certificateTemplate = data[i];
              break;
            }
          }
          if (!this.certificateTemplate?.template) {
            this.isDefaultTemplate = false;
          } else {
            this.isDefaultTemplate = true;
            this.buildCertificateData(this.certificateTemplate.template);
          }
          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);

          this.visibleCertificationPopup.afterClosed().subscribe(() => {
            this.backToPageWithConfirm();
          });
        },
        (error) => {

          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);

          this.visibleCertificationPopup.afterClosed().subscribe(() => {
            this.backToPageWithConfirm();
          });
          throw error;
        }
      );
      this.isWithScoreTemplate = false;
    }
  }
  openPopup1() {
    this.isDefaultTemplate = false;
    this.isWithScoreTemplate = false;

    const offScreenPopupConfig = {
      width: '1000px',
      height: 'auto',
      hasBackdrop: false,
      disableClose: true,
      position: { top: '-10000px', left: '-10000px' },
    };

    if (this.scoreperc != null || this.trainingData.finalScore != null) {
      this.appService.getTrainingCertificateTemplates().subscribe(
        (data: any) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].isDefaultWithscoreTemplate === "Y") {
              this.certificateTemplate = data[i];
              break;
            }
          }
          if (!this.certificateTemplate?.template) {
            this.isDefaultTemplate = false;
          } else {
            this.isDefaultTemplate = true;
            this.buildCertificateData1(this.certificateTemplate.template);
          }

          // Open off-screen
          this.visibleCertificationPopup1 = this.dialog.open(this.certificationPopup1, offScreenPopupConfig);

          this.visibleCertificationPopup1.afterOpened().subscribe(() => {
            this.cerStoredinServer();
          });

          this.visibleCertificationPopup1.afterClosed().subscribe(() => {
            this.cancelCompleteFunc();
          });
        },
        (error) => {
          this.visibleCertificationPopup1 = this.dialog.open(this.certificationPopup1, offScreenPopupConfig);
          this.visibleCertificationPopup1.afterOpened().subscribe(() => {
            this.cerStoredinServer();
          });
          this.visibleCertificationPopup1.afterClosed().subscribe(() => {
            this.cancelCompleteFunc();
          });
          throw error;
        }
      );
      this.isWithScoreTemplate = true;
    } else {
      this.appService.getTrainingCertificateTemplates().subscribe(
        (data: any) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].isDefaultWithoutscoreTemplate === "Y") {
              this.certificateTemplate = data[i];
              break;
            }
          }
          if (!this.certificateTemplate?.template) {
            this.isDefaultTemplate = false;
          } else {
            this.isDefaultTemplate = true;
            this.buildCertificateData1(this.certificateTemplate.template);
          }

          // Open off-screen
          this.visibleCertificationPopup1 = this.dialog.open(this.certificationPopup1, offScreenPopupConfig);

          this.visibleCertificationPopup1.afterOpened().subscribe(() => {
            this.cerStoredinServer();
          });
          this.visibleCertificationPopup1.afterClosed().subscribe(() => {
            this.cancelCompleteFunc();
          });
        },
        (error) => {
          this.visibleCertificationPopup1 = this.dialog.open(this.certificationPopup1, offScreenPopupConfig);
          this.visibleCertificationPopup1.afterOpened().subscribe(() => {
            this.cerStoredinServer();
          });
          this.visibleCertificationPopup1.afterClosed().subscribe(() => {
            this.cancelCompleteFunc();
          });
          throw error;
        }
      );
      this.isWithScoreTemplate = false;
    }
  }

  buildCertificateData(data: any) {
    if (data.includes("&lt;PERCENTAGE&gt;")) {
      console.log("this.trainingData.finalScore==", this.trainingData.finalScore);
      console.log("this.clickedContent.passPercentage==", this.clickedContent.passPercentage)
      data = data.split("&lt;PERCENTAGE&gt;").join(this.trainingData.finalScore == null ? this.scoreperc : this.trainingData.finalScore);
    }
    if (data.includes("&lt;ORG_NAME&gt;")) {
      data = data.split("&lt;ORG_NAME&gt;").join(this.orgData.orgLongName == null ? "" : this.orgData.orgLongName);
    }
    if (data.includes("&lt;ORG_LOGO&gt;")) {
      if (this.oneQmsOrgImagesDetails != undefined && this.oneQmsOrgImagesDetails != null) {
        data = data.split("&lt;ORG_LOGO&gt;").join(this.oneQmsOrgImagesDetails.logoImage);
      } else {
        data = data.split("&lt;ORG_LOGO&gt;").join("");
      }

    }
    if (data.includes("&lt;TRAINING_NAME&gt;")) {
      data = data.split("&lt;TRAINING_NAME&gt;").join(this.trainingData.trainingName);
    }
    if (data.includes("&lt;TRAINING_TYPE&gt;")) {
      data = data.split("&lt;TRAINING_TYPE&gt;").join(this.trainingData.type);
    }
    if (data.includes("&lt;COMPLETED_ON&gt;")) {

      let date = this.convertTZ(new Date(this.trainingData.completedOn), localStorage.getItem("timezone") != null ? localStorage.getItem("timezone") : "GMT")
      data = data.split("&lt;COMPLETED_ON&gt;").join(date);
    }
    if (data.includes("&lt;USER_FIRST_NAME&gt;")) {
      data = data.split("&lt;USER_FIRST_NAME&gt;").join(this.userDetails.firstName);
    }
    if (data.includes("&lt;USER_LAST_NAME&gt;")) {
      data = data.split("&lt;USER_LAST_NAME&gt;").join(this.userDetails.lastName);
    }
    if (data.includes("&lt;REASON_FOR_SIGN&gt;")) {
      data = data.split("&lt;REASON_FOR_SIGN&gt;").join(this.trainingData.reasonForSignature == null ? this.reasonForSign == null ? "" : this.reasonForSign : this.trainingData.reasonForSignature);
    }
    if (data.includes("&lt;USER_DESIGNATION&gt;")) {
      data = data.split("&lt;USER_DESIGNATION&gt;").join(this.userDetails.designation == null ? "" : this.userDetails.designation);
    }
    this.certificateData = this.sanitizer
      .bypassSecurityTrustHtml(data);
  }
  buildCertificateData1(data: any) {
    if (data.includes("&lt;PERCENTAGE&gt;")) {
      console.log("this.trainingData.finalScore=", this.trainingData.finalScore);
      console.log("this.clickedContent.passPercentage=", this.clickedContent.passPercentage)
      data = data.split("&lt;PERCENTAGE&gt;").join(this.trainingData.finalScore == null ? this.scoreperc : this.trainingData.finalScore);
    }
    if (data.includes("&lt;ORG_NAME&gt;")) {
      data = data.split("&lt;ORG_NAME&gt;").join(this.orgData.orgLongName == null ? "" : this.orgData.orgLongName);
    }
    if (data.includes("&lt;ORG_LOGO&gt;")) {
      if (this.oneQmsOrgImagesDetails != undefined && this.oneQmsOrgImagesDetails != null) {
        data = data.split("&lt;ORG_LOGO&gt;").join(this.oneQmsOrgImagesDetails.logoImage);
      } else {
        data = data.split("&lt;ORG_LOGO&gt;").join("");
      }

    }
    if (data.includes("&lt;TRAINING_NAME&gt;")) {
      data = data.split("&lt;TRAINING_NAME&gt;").join(this.trainingData.trainingName);
    }
    if (data.includes("&lt;TRAINING_TYPE&gt;")) {
      data = data.split("&lt;TRAINING_TYPE&gt;").join(this.trainingData.type);
    }
    if (data.includes("&lt;COMPLETED_ON&gt;")) {
      let date = this.convertTZ(new Date(), localStorage.getItem("timezone") != null ? localStorage.getItem("timezone") : "GMT")
      data = data.split("&lt;COMPLETED_ON&gt;").join(date);
    }
    if (data.includes("&lt;USER_FIRST_NAME&gt;")) {
      data = data.split("&lt;USER_FIRST_NAME&gt;").join(this.userDetails.firstName);
    }
    if (data.includes("&lt;USER_LAST_NAME&gt;")) {
      data = data.split("&lt;USER_LAST_NAME&gt;").join(this.userDetails.lastName);
    }
    if (data.includes("&lt;REASON_FOR_SIGN&gt;")) {
      data = data.split("&lt;REASON_FOR_SIGN&gt;").join(this.trainingData.reasonForSignature == null ? this.reasonForSign == null ? "" : this.reasonForSign : this.trainingData.reasonForSignature);
    }
    if (data.includes("&lt;USER_DESIGNATION&gt;")) {
      data = data.split("&lt;USER_DESIGNATION&gt;").join(this.userDetails.designation == null ? "" : this.userDetails.designation);
    }
    this.certificateData = this.sanitizer
      .bypassSecurityTrustHtml(data);
  }

  convertDate(date: any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();

    return `${day}-${monthName}-${year}`
  }
  progress: any;
  getContentListAndCalculateProgress(contentList: any) {
    let total = contentList.length;
    let statusCount = 0;
    for (let i = 0; i < contentList.length; i++) {
      if (contentList[i].status == "Completed") {
        statusCount += 1;
      }
    }
    let newNum: any = (statusCount / total) * 100;
    this.progress = Number(parseFloat(newNum)).toFixed(0);
    if (total == statusCount) {
      this.progress = 90;
    }

  }
  cancelCompleteFunc() {
    this.visibleConfirmComplete.close();
  }

  backToPageWithConfirm() {
    this.saveRemainingWaitTime(false);
    clearInterval(this.x);
    history.back();
  }

  cancelConfirmationFunc() {
    this.visibleConfirmation.close();
  }

  okConfirmation() {
    this.visibleCloseOfLaunchPage.close();
  }

  public downloadAsPdf(): void {
    let data: any;
    if (this.isDefaultTemplate) {
      data = document.getElementById('dataToExportFromTemp');  //Id of the table
    } else {
      data = document.getElementById('dataToExport');  //Id of the table
    }

    html2canvas(data).then(canvas => {
      // Few necessary setting options
      let imgWidth = 208;
      let pageHeight = 295;
      let imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf = this.addWaterMark(pdf);
      pdf.save('Certificate.pdf'); // Generated PDF
    });
  }

  public cerStoredinServer(): void {
    let data: any;

    if (this.isDefaultTemplate) {
      data = document.getElementById('dataToExportFromTemp');
    } else {
      data = document.getElementById('dataToExport');
    }
    setTimeout(() => {
      html2canvas(data, { useCORS: true, allowTaint: true, scale: 2 }).then(canvas => {
        this.visibleCertificationPopup1.close();

        let imgWidth = 208;
        let imgHeight = canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL('image/png');
        let pdf = new jspdf('p', 'mm', 'a4');
        pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf = this.addWaterMark(pdf);

        const pdfBlob = pdf.output('blob');
        const file = new File([pdfBlob], "CERTIFICATES_" + this.trainingData.trainingId + "_" + this.trainingData.userTrainingId + ".pdf", { type: "application/pdf" });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("pageName", "TMS");
        formData.append("fileName", "CERTIFICATES_" + this.trainingData.trainingId + "_" + this.trainingData.userTrainingId);
        formData.append("extension", "pdf");

        this.appService.fileUploadToServerCertificate(formData).subscribe({
          next: (res: any) => {
            this.cerFilePath = res.uploadPath;
            this.cerFileName = res.fileName + ".pdf";

            let dataSave: any = {};
            dataSave.userTrainingId = this.trainingData['userTrainingId'];
            dataSave.reasonForSignature = this.reasonForSign ?? null;
            dataSave.filePath = this.cerFilePath;
            dataSave.fileNme = this.cerFileName;

            this.appService.completeTraining(dataSave).subscribe((data1: any) => {
              this.previFirst = false;

              if (data1.resultType == "S") {
                // Show a quick success message
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 3000,
                  data: { message: data1.result, type: 'Success', buttonLabel: "Ok" },
                  horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'Success',
                });
                sb.onAction().subscribe(() => { sb.dismiss(); });

                // DIRECT REDIRECT (No more confirmation popup)
                clearInterval(this.x);
                this.router.navigate(['/dashboard/trainingDashboard']);

              } else {
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: { message: data1.result, type: 'Error', buttonLabel: "Ok" },
                  horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'Error',
                });
                sb.onAction().subscribe(() => { sb.dismiss(); });
              }
            });
          },
          error: (err) => {
            console.error("Upload Error", err);
          }
        });
      });
    }, 200); // Delay guarantees HTML is fully painted before capturing
  }
  addWaterMark(doc: any) {
    let timezone;
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let totalPages = doc.internal.getNumberOfPages();
    let watermark = "Printed by: " + localStorage.getItem("loggedUserName") + " | Printed on: " + this.convertTZ(new Date(), timezone) + "(" + timezone + ")";
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setTextColor(150);
      doc.text(5, doc.internal.pageSize.height - 5, watermark);
    }
    return doc;
  }
  convertDateAndTime(date: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();
    return `${day}-${monthName}-${year} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  }

  @ViewChild('logoutPopup', { static: true }) logoutPopup: TemplateRef<any>;
  visibleLogoutPopupPopup: MatDialogRef<TemplateRef<any>>;
  uploadImagesPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  title: any;
    // 1. Gather remaining time and trigger backend logout
  saveWaitTimeAndTriggerLogout() {
    const payload: any = {};
    
    // If there is an active training session with remaining time, attach it
    if (this.trainingData && this.clickedContent && this.distance > 0) {
      payload.userTrainingId = this.trainingData.userTrainingId;
      payload.trainingContentId = this.clickedContent.contentId;
      payload.trainingContentSeq = this.clickedContent.contentSeq;
      
      // Convert milliseconds to seconds (matches your BigDecimal remWaitTime)
      payload.remWaitTime = Math.ceil(this.distance / 1000); 
      payload.trainingAction = "SAVE_REM_TIME";
    }

    // Call the backend logout API with the payload
    this.appService.logOutUser().subscribe({ // payload need to be passsed here
      next: () => {
        this.proceedWithLocalLogout();
      },
      error: (err) => {
        console.error("Logout API failed, proceeding with local logout anyway", err);
        // Still proceed with local cleanup even if API fails
        this.proceedWithLocalLogout();
      }
    });
  }

  // 2. Extracted local cleanup logic
  private proceedWithLocalLogout() {
    if (this.x) {
      clearInterval(this.x);
    }
    this.messageService.setOrgId("");
    localStorage.setItem("userName", "");
    localStorage.setItem("email", "");
    this.messageService.setUserId("");
    localStorage.setItem("userprofilename", "");
    localStorage.setItem("userloagin", "N");
    
    this.title = "Confirm";
    this.visibleLogoutPopupPopup = this.dialog.open(this.logoutPopup, this.uploadImagesPopupConfig);
    this.router.navigate(['/login']);
  }

  // 3. This replaces your old logout() method
  logout() {
    this.saveWaitTimeAndTriggerLogout();
  }

  visibleNotificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('notificationPopup', { static: true }) notificationPopup: TemplateRef<any>;
  notificationPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  openNotifications() {
    this.qmsservice.activityId = null;
    this.visibleNotificationPopup = this.dialog.open(this.notificationPopup, this.notificationPopupConfig);
  }

  cancelNotificationPopup() {
    this.visibleNotificationPopup.close();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    // Use sendBeacon for browser back button / history navigation
    this.saveRemainingWaitTime(true);

    if (this.x) {
      clearInterval(this.x);
    }
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }
  convertTZ(date: any, timezone: any) {
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
    let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let date2 = dt.getFullYear() + "-" + month_names[dt.getMonth()] + "-" + dt.getDate();
    let date1 = moment(date2).format(this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase());
    let hours = dt.getHours();
    let minutes: any = dt.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return date1 + " " + strTime;
  }

  cancelCer() {
    this.visibleCertificationPopup.close();
  }

  cancelCer1() {
    this.visibleCertificationPopup1.close();
  }

  @HostListener('mousemove')
  @HostListener('mousedown')
  @HostListener('keydown')
  @HostListener('wheel')
  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }
  /**
   * Sends 'SAVE_REM_TIME' to backend only if minimum time is NOT completed.
   * @param useBeacon If true, uses navigator.sendBeacon (ideal for ngOnDestroy / tab close).
   */
  saveRemainingWaitTime(useKeepAlive: boolean = false): void {
    if (!this.trainingData || !this.clickedContent || this.distance <= 0) {
      return;
    }

    // Calculate balance remaining as WHOLE SECONDS (e.g., 57)
    const balanceSeconds = Math.ceil(this.distance / 1000);

    // Reset distance immediately to prevent duplicate calls from ngOnDestroy
    this.distance = 0;

    const payload = {
      userTrainingId: this.trainingData['userTrainingId'],
      trainingId: this.trainingData['trainingId'],
      version: this.trainingData['version'],
      contentId: this.clickedContent.contentId,
      contentSeq: this.clickedContent.contentSeq,
      contentExtn: this.clickedContent.contentExtn || null,
      status: this.clickedContent.status || 'In Progress',
      action: 'SAVE_REM_TIME',
      remWaitTime: balanceSeconds, // Sends exact seconds (57)
    };

    console.log('Saving Remaining Wait Time Payload:', payload);

    if (useKeepAlive) {
      const url = `${this.appService.baseUrl}/userTrainings/trainingContentAction`;
      fetch(url, {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        keepalive: true,
      }).catch((err) => console.error('Failed keepalive PUT save:', err));
    } else {
      this.appService.trainingContentAction(payload).subscribe({
        next: (res: any) => console.log('remWaitTime saved successfully:', res),
        error: (err: any) => console.error('Failed to save remWaitTime:', err),
      });
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: any): void {
    this.saveRemainingWaitTime(true);
  }

  @HostListener('window:pagehide', ['$event'])
  onPageHide(event: any): void {
    this.saveRemainingWaitTime(true);
  }
 
}
